export default __webpack_public_path__ + "static/media/a_wdt_c_3.55cb9aae.mp3";